<app-generic-card [title]="event.name" [showHeader]="true" [showTitle]="false" [showDescription]="false"
  [detailLink]="detailLink()" [canEdit]="canEdit()" [editLink]="editLink()" [editAriaLabel]="'Modifica evento: ' + event.name">

  <div card-header-extra>
    <p class="event-card-day mb-0">{{ event.startDate | dateRange:event.endDate }}</p>
  </div>

  <div card-content class="event-card-content">
    <div class="event-image-container mt-2">
      @if (event.imageUrl) {
        <img [src]="event.imageUrl" [alt]="event.name" class="event-image" loading="lazy">
      } @else {
        <span class="text-muted">Nessuna locandina</span>
      }
    </div>
  </div>

  <div card-footer class="col-12">
    <p class="event-card-place text-muted mb-1">
      @if (locationCityAndProvince()) {
      <i class="bi bi-geo-alt-fill me-1" aria-hidden="true"></i>{{ locationCityAndProvince() }}
      }
      @if (distanceLabel()) {
      <span class="event-card-distance"> · {{ distanceLabel() }}</span>
      }
    </p>
  </div>
</app-generic-card>
